import { useEffect, useState } from "react";
import firehoseSSEClient from "./firehoseSSEClient";

/**
 * Returns whether the firehose SSE client has fallen back to HTTP polling mode.
 * Mirrors useIsPollingMode for newsquawk headlines.
 */
export function useIsFirehosePollingMode(): boolean {
  const [isPolling, setIsPolling] = useState(
    firehoseSSEClient.getIsPollingMode()
  );

  useEffect(() => {
    const sub = firehoseSSEClient.onPollingModeChange(setIsPolling);
    return () => sub.unsubscribe();
  }, []);

  return isPolling;
}
